import React from "react";
import { Loader2 } from "lucide-react";

import { Button } from "../ui/button";

// Fixa no rodapé das páginas de detalhe: com o formulário dividido em abas, o
// botão de salvar não pode morar no fim de uma delas. Fica dentro do <Form>
// (o "Salvar" é type="submit").
//
// Mesmo desenho da barra local do WhatsAppModal (página da conexão).
// `rotulo` troca o texto do botão e `aviso` o "Tudo salvo." no cadastro novo,
// onde ainda não há nada salvo.
const BarraDeSalvar = ({
	alterado,
	salvando,
	bloqueado,
	onDescartar,
	rotulo = "Salvar alterações",
	aviso,
}) => (
	<div className="sticky bottom-0 z-10 -mx-4 flex flex-wrap items-center justify-end gap-2 border-t bg-background/95 px-4 py-3 backdrop-blur sm:-mx-6 sm:px-6">
		<span className="mr-auto text-xs text-muted-foreground">
			{bloqueado
				? `Há um campo com erro em “${bloqueado}”.`
				: aviso ||
				  (alterado ? "Alterações não salvas." : "Tudo salvo.")}
		</span>
		<Button
			type="button"
			variant="outline"
			onClick={onDescartar}
			disabled={!alterado || salvando}
		>
			Descartar
		</Button>
		<Button type="submit" disabled={!alterado || salvando || Boolean(bloqueado)}>
			{salvando && <Loader2 className="h-4 w-4 animate-spin" />}
			{rotulo}
		</Button>
	</div>
);

export default BarraDeSalvar;
